<div
  *ngIf="numberOfErrors > 0"
  class="make-correction-container"
  id="correctionBar"
  tabindex="-1"
>
  <span class="correction-message">To continue,</span>
  <a
    (click)="makeCorrectionClicked()"
    class="continue-link"
    href="javascript:void(0);"
  >
    please correct the {{ numberOfErrors }}
    {{ numberOfErrors > 1 ? 'items' : 'item' }} indicated
  </a>
</div>
